<template>
<div class="chapter">
<div class="inner_page">
<p class="praise"><span href="#/OEBPS/toc#pra" title="Link target outside of Sample">Praise for <em>When Giants Walked the Earth</em></span></p>
<p class="nonindent1">‘So this is the big one: a fat, juicy biography of the biggest band ever … Mick Wall, the veteran rock journalist, lays it all bare in a book that can only be described as definitive.’</p>
<p class="right"><em>Daily Telegraph</em></p>
<p class="nonindent1">‘As well as being the most complete account yet of a great British rock band, <em>When Giants Walked the Earth</em> is, as its name implies, a document of a bygone age. … Wall has done his subject proud.’</p>
<p class="right"><em>The Sunday Times</em></p>
<p class="nonindent1">‘That Wall can add so much fresh detail to the Led Zep story is in itself an extraordinary achievement. That he manages to humanise these planet-striding giants while doing so puts this book into the definitive category’</p>
<p class="right"><em>Classic Rock</em> magazine</p>
<p class="nonindent1">‘It deftly strikes the balance between lofty authority and finding a way to get inside the heads of its subjects’</p>
<p class="right"><em>Guardian</em></p>
<p class="nonindent1">‘The very best and most cogently argued account – of a long-ago time when men with Gibsons were the knights errant of the land, striding across stages shrouded in mist, soloing at great length!’</p>
<p class="right"><em>New York Times</em></p>
<p class="nonindent1">‘As Zeppelin’s success skyrocketed in the 1970s, Page and Plant openly courted an unearthly, occult identity for the band. There seemed to be an obscure system of symbolism and ritual at work that seeped into the albums and performances, creating for Page “an energy … that the audience picked up on and sent back to us.” Really powerful stuff.’</p>
<p class="right"><em>LA Times</em></p>
<p class="nonindent1">‘This fantastic account of Led Zeppelin’s wild and decadent heyday is as detailed and definitive as music biographies can get’</p>
<p class="right"><em>London Lite</em></p>
<p class="nonindent1">‘An essential source for anyone eager to learn about the era when rock stars ruled the world’</p>
<p class="right"><em>Publishers Weekly</em></p>
<p class="nonindent1">‘The definitive account of rock legends Led Zeppelin’</p>
<p class="right"><em>Daily Record</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pra.vue?134d737a